// The board moves to a new address (kioskMove.nl.ts). English counterpart.
export const kioskMoveEn = {
    title: 'The board is moving',
    body: 'The family board has a new address: {host}. It is going there now and stays paired.',
    askBody: 'The family board has a new address: {host}. Tap Continue: Safari opens the board there, still paired. After that we explain how to add it to the Home Screen again.',
    askBodyUnpaired: 'The family board has a new address: {host}. Tap Continue to open it there and pair it.',
    button: 'Continue',
    later: 'Later',
    failed: 'Moving does not work right now. The board will try again shortly.',
    homeTitle: 'Add the board to the Home Screen again',
    homeBody: 'The board now lives at {host}. In Safari, tap Share and then "Add to Home Screen". Then open the board straight away from the new icon and remove the old icon. If the new icon asks for a code, pair it again in the app. Then close this explanation in Safari.',
    invalid: 'This moving code has expired or was already used. Pair the board again with the code on this screen.',
    offline: 'No connection, so the move did not work. Pair the board again with the code on this screen.',
    /** De ouderapp heeft deze tablet losgekoppeld (koppelscherm). */
    revoked: 'Unpaired in the parent app.',
};
//# sourceMappingURL=kioskMove.en.js.map